import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { LightThemeProvider } from '@platform-ui/design-system';
/* Special Snowflake: This is a blend of the ParentElement and ChildElement abstracts. */

export var DSAccordions = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DSAccordions, _HTMLElement);

  var _super = _createSuper(DSAccordions);

  function DSAccordions() {
    var _this;

    _classCallCheck(this, DSAccordions);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "mount", void 0);

    _this.mount = document.createElement('div');
    return _this;
  }

  _createClass(DSAccordions, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var children, elem;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                children = Array.from(this.children) // @ts-ignore
                .map(function (child) {
                  return child.elem;
                }).filter(Boolean);
                elem = React.createElement.apply(React, [LightThemeProvider, null].concat(_toConsumableArray(children)));
                ReactDOM.render(elem, this.mount);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function render() {
        return _render.apply(this, arguments);
      }

      return render;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.appendChild(this.mount);
      this.render();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (!document.body.contains(this)) {
        ReactDOM.unmountComponentAtNode(this.mount);
      }

      this.removeChild(this.mount);
    }
  }]);

  return DSAccordions;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
//# sourceMappingURL=Accordions.js.map